/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IGutachtenBefangenheitDisplayModel {
  befangenheit?: boolean;
  begruendungBefangenheit?: null | string;
  id?: string;
}
export class GutachtenBefangenheitDisplayModel extends BaseModel implements IGutachtenBefangenheitDisplayModel {
  befangenheit?: boolean;
  begruendungBefangenheit?: null | string;
  id?: string;
}
class BaseGutachtenBefangenheitDisplayModelFormGroup extends FormGroup {
  private static _instance: GutachtenBefangenheitDisplayModelFormGroup;
  
  public static get Instance(): GutachtenBefangenheitDisplayModelFormGroup {
    this._instance = new GutachtenBefangenheitDisplayModelFormGroup({
      befangenheit: new FormControl(null),
      begruendungBefangenheit: new FormControl(null),
      id: new FormControl(null),
    });

    return this._instance;
  }
}


export class GutachtenBefangenheitDisplayModelFormGroup extends BaseGutachtenBefangenheitDisplayModelFormGroup {
  public get Befangenheit(): FormControl {
    return this.controls["befangenheit"] as FormControl;
  }
  public get BegruendungBefangenheit(): FormControl {
    return this.controls["begruendungBefangenheit"] as FormControl;
  }
  public get Id(): FormControl {
    return this.controls["id"] as FormControl;
  }
  

}

export module GutachtenBefangenheitDisplayModelForm
  {
    export class FormFields
    {
      static _befangenheit: string = "befangenheit";
      static _begruendungBefangenheit: string = "begruendungBefangenheit";
      static _id: string = "id";
    }
  }

